import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import isEmpty from "lodash/isEmpty";
import { useRetailerNodes } from "../retailer/useRetailerNodes";
import { useSelfServeContextStore } from "./SelfServeContext";
import { useBrandNodes } from "./useBrandNodes";
export var useTree = function useTree() {
  var _useSelfServeContextS = useSelfServeContextStore(["tree"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 2),
    tree = _useSelfServeContextS2[0].tree,
    setSelfServeContextStore = _useSelfServeContextS2[1];
  var RETAILER_NODES = useRetailerNodes();
  var BRAND_NODES = useBrandNodes();
  if (!isEmpty(tree)) {
    return {
      tree: tree
    };
  }
  var lazilyConstructedNodes = isRetailer() ? RETAILER_NODES : BRAND_NODES;
  setSelfServeContextStore({
    tree: lazilyConstructedNodes
  });
  return {
    tree: lazilyConstructedNodes
  };
};